// UsedWorkHistoriesModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { FONT_SIZE } from "../../../constants/fontSizes";
import { TEXT_COLOR_PRIMARY } from "../../../constants/colors";

/**
 * 使用した work_history 一覧を表示する共通モーダル
 *
 * Props：
 * @param {boolean} open - モーダルの表示／非表示
 * @param {Function} onClose - モーダルを閉じる処理
 * @param {string} title - モーダルタイトル（例：「Ruby を使用したプロジェクト」）
 * @param {Array} workHistories - 表示する work_history 一覧
 * @param {Function} onClickWorkHistory - プロジェクトクリック時の処理
 */
const UsedWorkHistoriesModal = ({
  open,
  onClose,
  title,
  workHistories,
  onClickWorkHistory,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      {/* タイトル */}
      <DialogTitle sx={{ fontWeight: "bold" }}>{title}</DialogTitle>

      {/* プロジェクト一覧 */}
      <DialogContent>
        <List sx={{ p: 0 }}>
          {(workHistories || []).map((workHistory) => (
            <ListItemButton
              key={workHistory.id}
              onClick={() => onClickWorkHistory(workHistory.id)}
              sx={{
                fontSize: FONT_SIZE.XS,
                color: TEXT_COLOR_PRIMARY,
                px: 0,
                "&:hover": { textDecoration: "underline" },
              }}
            >
              <ListItemText primary={`・${workHistory.name}`} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default UsedWorkHistoriesModal;
